import { AiAssistantButton } from '@elva/ai-chat';
import React from 'react';
import { Button } from '../Button/Button';
import { IconButton } from '../IconButton/IconButton';

export interface FormsTopBarActionsProps {
  packageCount?: number;
  onManagePackages?: () => void;
  onCreate?: () => void;
  onBell?: () => void;
}

export function FormsTopBarActions({
  packageCount = 0,
  onManagePackages,
  onCreate,
  onBell,
}: FormsTopBarActionsProps) {
  return (
    <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
      <span className="inline-flex h-8 items-center gap-1.5 rounded-[var(--r-pill)] bg-[var(--ai-tint)] px-[11px]">
        <span className="cal-live" />
        <span className="text-[11.5px] font-semibold text-[var(--ai-3)]">Live</span>
        <span className="font-[var(--font-mono)] text-[11px] text-[var(--ink-3)]">now</span>
      </span>
      <IconButton icon="bell" size={32} onClick={onBell} label="Notifications" />
      <Button variant="secondary" size="sm" iconLeft="folder" onClick={onManagePackages}>
        Packages {packageCount}
      </Button>
      <Button variant="primary" size="sm" iconLeft="plus" onClick={onCreate}>
        Create form
      </Button>
      <AiAssistantButton />
    </div>
  );
}
